import { gql, useQuery } from '@apollo/client';
import { CurrencyFormats } from '../../contracts/types';
import { useCurrentTripId } from '../search';
export const TRIP_STATE_FRAGMENT = `
            tripStateId
            searchParameters {
                tripStateId
                startDate
                endDate
                hotelIds
                hotelTitle
                destinationIds
                destinationTitle
                rooms {
                    adults
                    childAges
                }
                tripType
                numberOfNights
                isNumberOfNightsAdjusted
                flightDetailsId
                departureAirports
                arrivalAirports
                adults
                childAges
                isArrivalAnywhere
                isDirectOnly
                cabin
                destinations {
                    id
                    type
                    title
                    isCached
                    subTitle
                }
                flightJourneyType
            }
            basket {
                basketId
                hotelProducts {
                    totalDiscount
                    tototalDiscountFormatted
                    totalAmountFormatted
                    totalWithoutDiscount
                    totalWithoutDiscountFormatted
                    promoDiscount
                    promoDiscountFormatted
                    lineItems {
                        description
                        typeId
                        unitAmount
                        unitAmountFormatted
                        quantity
                    }
                    itinerary {
                        ... on BasketHotelItinerary {
                            checkInDate
                            checkOutDate
                            nights
                            durationSummary
                            transfersCost
                            transfersCostFormatted
                            additionalInfo {
                                title
                                description
                            }
                            mandatoryExtras {
                                title
                                options {
                                    hotelExtraOptionId
                                    customerText
                                }
                                hotelExtraTypeId
                                hotelExtraId
                            }
                                hotel {
                                    estabId
                                    callout {
                                        id
                                        text
                                        themeColor
                                    }
                                    geography {
                                        address
                                        country
                                        latitude
                                        location
                                        longitude
                                        postcode
                                        province
                                    }
                                    indicativeMinPrice
                                    indicativeMinPriceFormatted
                                    name
                                    overview
                                    pageStrand
                                    tripadvisorFeedback {
                                        rating
                                        numberOfReviews
                                        ratingImageUrl
                                        tripAdvisorURL
                                        reviews {
                                            title
                                            comment
                                            publishedDate
                                            ratingImageUrl
                                        }
                                    }
                                    trustYouReviewClusterId
                                    customerFeedback {
                                        overallRating
                                        overallRatingDescription
                                        numberOfReviews
                                    }
                                    starRating
                                    tags {
                                        id
                                        text
                                        themeColor
                                    }
                                    url
                                }
                            rooms {
                                boardType
                                isPayAtHotel
                                nonRefundable
                                occupancySummary
                                price
                                priceFormatted
                                refundableCutOffDate
                                refundableCutOffMsg
                                roomDescription
                                title
                                hypeMessages {
                                    description
                                    descriptionHeader
                                    title
                                    type
                                }
                            }
                            roomsTotalWithoutTransfers
                            roomsTotalWithoutTransfersFormatted
                            transfersCost
                            transfersCostFormatted
                            cityTaxFormatted
                            cityTax
                            availabilityDetails {
                                pricingSummary {
                                  cityTax
                                  cityTaxFormatted
                                  callout {
                                    id
                                    text
                                    themeColor
                                  }
                                }
                              }
                        }
                    }
                }
                flightProducts {
                    totalAmount
                    lineItems {
                        description
                        typeId
                        unitAmount
                        unitAmountFormatted
                        quantity
                    }
                    itinerary {
                        ... on BasketFlightItinerary {
                            holdBaggageAdded {
                                totalCostFormatted
                                totalCost
                                chosenQuantity
                                bags {
                                    maxWeightKg
                                    optionId
                                    isDefault
                                    description
                                    type
                                    perPersonCost
                                    perPersonCostFormatted
                                    unitCost
                                    unitCostFormatted
                                    chosenQuantity
                                }
                            }
                            priorityBoardingAdded {
                                totalCostFormatted
                                totalCost
                                chosenQuantity
                                description
                            }
                            additionalInformation
                            flightDetails {
                                flightDetailsId
                                tripStateId
                                flightSearchId
                                flightId
                                supplierFareRules
                                outboundLeg {
                                    duration
                                    stops
                                    totalBagsIncluded
                                    dayDifference
                                    savingsForPromotedFlights
                                    segments {
                                        airline {
                                            name
                                            imageName
                                        }
                                        flightNumber
                                        departureTerminal
                                        arrivalTerminal
                                        departureAirport {
                                            airportCode
                                            title
                                        }
                                        arrivalAirport {
                                            airportCode
                                            title
                                        }
                                        operatingAirline {
                                            name
                                            code
                                            imageName
                                        }
                                        departureDateTime {
                                            date(format: DEFAULT)
                                            time
                                        }
                                        arrivalDateTime {
                                            date(format: DEFAULT)
                                            time
                                        }
                                        departureDateFormatted
                                        arrivalDateFormatted
                                        layoverTime
                                        dayDifference
                                        cabinClass
                                        duration
                                    }
                                    airlines {
                                        name
                                        code
                                        imageName
                                        verifiedByContent {
                                            imageUrl
                                        }
                                    }
                                    departureAirport {
                                        airportCode
                                        title
                                    }
                                    arrivalAirport {
                                        airportCode
                                        title
                                    }
                                    departureDateTime {
                                        date(format: DEFAULT)
                                        time
                                    }
                                    arrivalDateTime {
                                        date(format: DEFAULT)
                                        time
                                    }
                                }
                                inboundLeg {
                                    duration
                                    stops
                                    totalBagsIncluded
                                    dayDifference
                                    savingsForPromotedFlights
                                    segments {
                                        airline {
                                            name
                                            imageName
                                        }
                                        flightNumber
                                        departureTerminal
                                        arrivalTerminal
                                        departureAirport {
                                            airportCode
                                            title
                                        }
                                        arrivalAirport {
                                            airportCode
                                            title
                                        }
                                        operatingAirline {
                                            name
                                            code
                                            imageName
                                        }
                                        departureDateTime {
                                            date(format: DEFAULT)
                                            time
                                        }
                                        arrivalDateTime {
                                            date(format: DEFAULT)
                                            time
                                        }
                                        departureDateFormatted
                                        arrivalDateFormatted
                                        layoverTime
                                        dayDifference
                                        cabinClass
                                        duration
                                    }
                                    airlines {
                                        name
                                        code
                                        imageName
                                        verifiedByContent {
                                            imageUrl
                                        }
                                    }
                                    departureAirport {
                                        airportCode
                                        title
                                    }
                                    arrivalAirport {
                                        airportCode
                                        title
                                    }
                                    departureDateTime {
                                        date(format: DEFAULT)
                                        time
                                    }
                                    arrivalDateTime {
                                        date(format: DEFAULT)
                                        time
                                    }
                                }
                            }
                        }
                    }
                }
                payFullDetails {
                    totalAmount
                    totalAmountFormatted
                    pricePerPersonAmount
                    totalAmountRounded: totalAmountFormatted(format: ${CurrencyFormats.Rounded})
                    subTotalAmount
                    subTotalAmountFormatted
                    totalDirectPaymentAmount
                    totalDirectPaymentAmountFormatted
                    directPayments {
                        amount
                        amountFormatted
                        currency
                        localAmount
                        localAmountFormatted
                        localCurrency
                    }
                }
                payDepositDetails {
                    totalAmount
                    totalAmountFormatted
                    pricePerPersonAmount
                    totalDirectPaymentAmount
                    totalDirectPaymentAmountFormatted
                    totalImmediatePaymentAmount
                    totalImmediatePaymentAmountFormatted
                    futurePaymentDueDate
                    futurePaymentAmount
                    futurePaymentAmountFormatted
                    totalFuturePaymentAmount
                    totalFuturePaymentAmountFormatted
                    unitAdminFee
                    unitAdminFeeFormatted
                    totalAdminFee
                    totalAdminFeeFormatted
                    futurePayments {
                        amount
                        due
                        futurePaymentDueDate
                        futurePaymentAmountFormatted
                    }
                    directPayments {
                        amount
                        amountFormatted
                        currency
                        localAmount
                        localAmountFormatted
                        localCurrency
                    }
                }
                atolProtection {
                    totalAmount
                    totalAmountFormatted
                }
                discountMessages {
                    code
                    message
                }
                totalPriceWithoutAtolAndBaggage
                totalPriceWithoutAtolAndBaggageFormatted
                voucherCode
                covidProtection {
                    totalAmount
                    totalAmountFormatted
                }
                insuranceProducts {
                    options {
                        optionId
                        chosenQuantity
                    }
                    productId
                    totalAmount
                    totalAmountFormatted
                    itinerary {
                        ... on BasketInsuranceItinerary {
                            policyTitle
                            customerCount
                        }
                    }
                }
                attractionProducts {
                    productId
                    productType
                    totalAmount
                    totalAmountFormatted
                    lineItems {
                        description
                        unitAmountFormatted(format: FORMATTED)
                        quantity
                        totalAmountFormatted(format: FORMATTED)
                    }
                }
                transferProducts {
                    productId
                    productType
                    totalAmount
                    pricePerPersonAmount
                    totalAmountFormatted
                    itinerary {
                        ... on BasketTransferItinerary {
                            transferType
                            customerCount
                        }
                    }
                }
            }
            insuranceRequest {
                datesOfBirth
            }
            bookingForm {
                bookingProcessId
                bookingConditions
                paymentOptions {
                    id
                    name
                    type
                }
                insuranceBands {
                    id
                    startAge
                    endAge
                }
                paymentRules {
                    recurringPayments {
                        paymentSchedules {
                            totalToPay
                            totalToPayFormatted
                            totalAdminFees
                            totalAdminFeesFormatted
                            installments {
                                dueDate
                                dueDateFormatted
                                installmentCost
                                installmentCostFormatted
                                adminFee
                                adminFeeFormatted
                            }
                        }
                        allowed
                    }
                    isFullAmountAllowed
                    isDepositAllowed
                }
                userData {
                    contact {
                        address
                        city
                        countryCode
                        county
                        email
                        emailSignUp
                        firstName
                        lastName
                        mobileTel
                        postCode
                        title
                    }
                    covidWaiverAccepted

                    rooms {
                        guests {
                            age
                            firstName
                            lastName
                            title
                            type
                            dateOfBirth
                            dateOfBirthFormatted
                            linkedBkItemSeqNo
                            insuranceBandId
                        }
                        specialRequest
                    }
                    paymentDetails {
                        paymentStructure
                    }
                    connectingFlight {
                        inboundDate
                        inboundArrivalDate
                        inboundDepartureDate
                        inboundFlightNumber
                        outboundDate
                        outboundDepartureDate
                        outboundArrivalDate
                        outboundFlightNumber
                    }
                }
            }
            countries {
                name
                code
            }
            hotelsRequest {
                checkInDate
                checkOutDate
            }
            flightsRequest {
                departureDate
                returnDate  
            }
            transfersRequest {
                availabilitySearchId
                airport
                airportTitle
                route {
                    pickUpPoint {
                        type
                        code
                        title
                        description
                    }
                    dropOffPoint {
                        type
                        code
                        title
                        description
                    }
                }
                resortId
                resortTitle
                locationId
                startDate
                endDate
                adults
                childAges
                destinationAirport {
                    code
                    title
                    shortTitle
                }
            }
            transferSupportingDetails {
                updatedHotelDetails {
                    name
                    address
                }
                updatedConnectingFlightDetails {
                    inbound {
                        flightNumber
                        date
                        departureDate
                        arrivalDate
                        departureAirportCode
                        departureAirportName
                        destinationAirportCode
                        destinationAirportName
                    }
                    outbound {
                        flightNumber
                        date
                        departureDate
                        arrivalDate
                        departureAirportCode
                        departureAirportName
                        destinationAirportCode
                        destinationAirportName
                    }
                }
            }
`;
const TRIP_STATE_QUERY = gql `
    query GETTRIPSTATE($tripStateId: ID!) {
        getTripState(tripStateId: $tripStateId) {
            ${TRIP_STATE_FRAGMENT}
        }
    }
`;
export function useTripState(skipQuery = false) {
    var _a, _b;
    const [tripIdState] = useCurrentTripId();
    return useQuery(TRIP_STATE_QUERY, {
        notifyOnNetworkStatusChange: true,
        ssr: false,
        skip: skipQuery || !((_a = tripIdState.data) === null || _a === void 0 ? void 0 : _a.currentTripStateId),
        variables: {
            tripStateId: (_b = tripIdState.data) === null || _b === void 0 ? void 0 : _b.currentTripStateId,
        },
    });
}
